import React from 'react';
import HamburgerMenu from '../global/menu';
import '../global/styles.css';

function HamiltonT1Duration({ userInfo, isAdmin, onLogout, onNavigate }) {
  return (
    <div className="container-center" style={{ paddingBottom: '80px' }}>
      {/* Hamburger Menu */}
      <HamburgerMenu
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      <div className="card card-center" style={{
        maxWidth: '1000px',
        width: '100%',
        padding: '40px'
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '30px',
          borderBottom: '2px solid #0E3293',
          paddingBottom: '20px'
        }}>
          <h2 style={{
            fontSize: '32px',
            fontWeight: 'bold',
            color: '#0E3293',
            margin: '0 0 15px 0',
            letterSpacing: '-0.5px'
          }}>
            Hamilton T1 High-Flow Cylinder Durations
          </h2>
          <p style={{
            fontSize: '16px',
            color: '#777',
            margin: '0',
            lineHeight: '1.6'
          }}>
            Reference guide for oxygen cylinder duration calculations
          </p>
        </div>

        {/* PDF Viewer */}
        <div style={{
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '12px',
          boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.05)'
        }}>
          <iframe
            src="/Hamilton T1 High-Flow Cylinder Durations.pdf"
            title="Hamilton T1 High-Flow Cylinder Durations"
            style={{
              width: '100%',
              height: '70vh',
              border: 'none',
              borderRadius: '8px',
              background: 'white'
            }}
          />
        </div>

        {/* Download Button */}
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <a
            href="/Hamilton T1 High-Flow Cylinder Durations.pdf"
            download
            className="btn btn-primary"
            style={{
              background: '#0E3293',
              borderColor: '#0E3293',
              padding: '12px 30px',
              fontSize: '16px',
              fontWeight: '600',
              textDecoration: 'none',
              display: 'inline-block'
            }}
          >
            Download PDF
          </a>
        </div>
      </div>

      {/* Fixed Footer */}
      <footer style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        background: '#ffffff',
        textAlign: 'center',
        padding: '15px 10px',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.08)',
        zIndex: 9999,
        borderTop: '1px solid #e0e0e0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          flexWrap: 'wrap'
        }}>
          <img
            src="https://us.api.fliplet.com/v1/media/files/5174683/contents/blob"
            alt="NarcoticTrack Logo"
            style={{
              height: '32px',
              verticalAlign: 'middle'
            }}
          />
          <span style={{
            fontSize: '14px',
            color: '#666',
            fontWeight: '400'
          }}>
            © 2025 NarcoticTrack Inventory System, LLC
          </span>
        </div>
      </footer>
    </div>
  );
}

export default HamiltonT1Duration;
